import { CustomSelectOption, FormItem, CustomSelect } from '@vkontakte/vkui';
import PropTypes from 'prop-types';
import React from 'react';

export const StatusSelectComponent = ({value, setValue, options, error, setError, label}) => {
  return (<FormItem
    top={label}
    status={error.length > 0 ? 'error' : ''}
    bottom={error}
  >
    <CustomSelect
      onChange={(event) => {
        setValue(event.target.value);
        setError('');
      }}
      value={value || undefined}
      options={options}
      renderOption={({ option, ...restProps }) => (
        <CustomSelectOption
          {...restProps}
          key={option.value}
        />
      )}
    />
  </FormItem>)
}

StatusSelectComponent.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};
